define.alias("shared/utils/object-methods/stack-object-array-values", "calendar/utils/object-methods/stack-object-array-values");